import { useEffect, useRef, useState } from 'react';

// The hover "⋯" menu (plan §7d, owner decision 2): the ⋯ button is invisible
// until its host (a card or a row with class `seg-hover-host`) is hovered or
// the menu is open; a click opens a small list of the corrections. Nothing is
// presented as awaiting approval.
export default function SegMenu({ items, label = '⋯', title = 'Fix this document', className = '', align = 'right' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDoc, true);
    document.addEventListener('keydown', onKey, true);
    return () => { document.removeEventListener('mousedown', onDoc, true); document.removeEventListener('keydown', onKey, true); };
  }, [open]);
  const visible = (items || []).filter(Boolean);
  if (!visible.length) return null;
  return (
    <div ref={ref} className={`seg-menu${open ? ' seg-menu--open' : ''} seg-menu--${align} ${className}`} onClick={(e) => e.stopPropagation()}>
      <button type="button" className="seg-menu-btn" title={title} aria-haspopup="menu" aria-expanded={open}
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}>{label}</button>
      {open && (
        <div className="seg-menu-pop" role="menu">
          {visible.map((it) => (
            <button key={it.key} type="button" role="menuitem" className={`seg-menu-item${it.danger ? ' seg-menu-item--danger' : ''}`}
              disabled={it.disabled} title={it.title || ''} data-menu-item={it.key}
              onClick={(e) => { e.stopPropagation(); setOpen(false); it.onSelect?.(); }}>
              {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
